module.exports = __webpack_public_path__ + "static/media/sparrow-chirping.edd62fa2.png";